/**
 * @description 土地盲盒分享-邀新
 * @returns /front/activities/regularShare/invite-land
 */
import Library from 'library';
import Service from './service';
import ActivityShareModal from 'components/activityShareModal';
import Interceptor from '../component/interceptor';
import React, { useState, useEffect } from 'react';
import { Toast } from 'antd-mobile';
import { Header, RulesModal } from 'components';
import Styles from "./index.module.scss";
const { JsBridge } = Library;

const InviteLand = (props) => {
  const [activityInfo, setActivityInfo] = useState({})

  useEffect(()=>{
    refeshData(true);
  },[])

  const refeshData = async (showLoading = false)=> {
    const result = await Service.getInitData(showLoading)

    if(result?.data) {
      setActivityInfo(result.data)
    }
    return result?.data

  }
  // 活动规则
  const onRuleClick =()=>{
    RulesModal.open({
      btnStyle: {background: 'linear-gradient(90deg, #FF431F 0%, #FF1858 100%)'},
      activityCode: Service.activityCode,
      codeType: 'activityRule',
      code: Service.activityCode
    });
  }
  // 邀新记录
  const onInviterRecord = () => {
    if (JsBridge.hasWebViewBridge()) {
      JsBridge.push('CustomWeb',{uri:`${window.location.origin}/front/activities/regularShare/invite-land-record`});
    }else {
      props.history.push('/front/activities/regularShare/invite-land-record')
    }
  }
  const onInvite = ()=> {
    const cuttentTime = activityInfo?.systemTime ? new Date(activityInfo?.systemTime?.replace(/-/g, '/')) : new Date();
    const isEnd = cuttentTime.getTime() - new Date(activityInfo?.endTime?.replace(/-/g, '/')).getTime();
    if(!activityInfo?.endTime || isEnd >= 0) {
      Toast.show('活动已结束');
      return;
    }
    const param = {
      ic: activityInfo.inviteCode,
      ac: Service.activityCode
    }
    const shareUrl = `${window.location.origin}/front/inviter/registers/${Buffer.from(JSON.stringify(param)).toString("base64")}`;
    ActivityShareModal.open({
      shareUrl,
      qrcodeConfig: {size: 65},
      children: <img className={Styles.shareInvite} src={require('images/invite-land/shareBg.png')} alt="bg" />,
    })

  }

  return (
    <div className={Styles.invite_zone}>
      {
        JsBridge.hasWebViewBridge() &&
        <Header bgColor={'transparent'} theme={'light'} />
      }
      <div className={Styles.body_wraper}>
        <div className={Styles.bgTop}>
          <div className={Styles.activityBtns}>
            <div onClick={onRuleClick}>规则</div>
            <div onClick={onInviterRecord}>邀新记录</div>
          </div>
        </div>
        <div className={Styles.bgCenter}>
          {/*立即邀新*/}
          <div className={Styles.inviteBtn} onClick={onInvite}>
            <img src={require('images/invite-land/invite-now.png')} alt="" />
          </div>
          <div className={Styles.textContent}>
            <img src={require('images/invite-land/text-content.png')} alt="" />
          </div>
        </div>
        {/* 底部logo */}
        <div className={Styles.footer_logo}>
          <img src={require('images/invite-zone/bottom-logo.png')} alt="" />
        </div>
        <Interceptor />
      </div>
    </div>
  )
}
export {
  InviteLand
}
